import { Eye } from 'lucide-react';
import { getViewAs, endViewAs } from '@/lib/api';

/** Shown on every page while an admin is viewing the app as someone else.
 *  Loud on purpose: nothing done in this mode is real, and the server refuses
 *  every write anyway. */
export default function ViewAsBanner() {
  const v = getViewAs();
  if (!v) return null;
  const exit = () => { endViewAs(); window.location.href = '/admin'; };
  return (
    <div data-testid="view-as-banner" className="sticky top-0 z-[80] bg-amber-400 text-slate-950 text-sm px-4 py-2 flex items-center justify-between gap-3">
      <span className="flex items-center gap-2">
        <Eye size={15} />
        <span><b>Viewing as {v.display_name}</b> ({v.role}). Read-only: nothing you do here changes anything.</span>
      </span>
      <button onClick={exit} className="font-semibold underline underline-offset-2 whitespace-nowrap">Exit view</button>
    </div>
  );
}
